export const DOCUMENT_TYPE = {
  TRADE_LICENSE: 1,
  RERA_REGISTRATION: 2,
  BROKERAGE_LICENSE: 3,
  EMIRATE_ID_OR_PASSWORD_COPIES: 4,
  POWER_OF_ATTORNEY: 5,
  AGENT_DOCS: 6,
  UNDER_OFFER_MOU: 7,
  FORM_F: 8,
  NEW_TITLE_DEED: 9,
  OLD_TITLE_DEED: 10,
  EJARI_CONTRACT: 11,
  TITLE_DEED: 12,
  MOU_OR_FORM_F: 13,
  TITLE_DEED_OR_SPA: 14,
  TENANCY_AGREEMENT: 15,
  MOU_DOCUMENTS: 16,
  EMIRATES_ID: 17,
  DTCM_PERMIT_NUMBER: 18,
  ADREC_OR_DARI_CARD: 19,
  LABOUR_OR_EMPLOYMENT_VISA: 20,
  SPA: 21,
  VAT: 23,
};

export const DOCUMENT_NAME: Record<number, string> = {
  1: "Trade License documents",
  2: "RERA Registration documents",
  3: "Brokerage License documents",
  4: "Emirates ID or Passport Copies",
  5: "Power of Attorney documents",
  6: "BRN Documents",
  7: "Under Offer MOU documents",
  8: "Form F documents",
  9: "New Title Deed documents",
  10: "Old Title Deed documents",
  11: "Ejari or Tenancy Agreement documents",
  12: "Title Deed or Utility Bill documents",
  13: "MOU or Form F documents",
  14: "Title Deed or SPA documents",
  15: "Tenancy Agreement documents",
  16: "MOU documents",
  17: "Emirates ID documents",
  18: "DTCM Permit Number",
  19: "ADREC or DARI Card documents",
  20: "Labour or Employment Visa documents",
  21: "Spa documents",
  23: "Vat Certificates",
};

export const AGENCY_TYPE = {
  REAL_ESTATE_BROKER: 1,
  SHORT_TERM_RENTALS: 2,
};

export const AGENT_EMIRATE = {
  DUBAI_BASED: 1,
  ABU_DHABI: 2,
  OTHERS: 3,
};

export const AGENT_EMIRATE_NAME: Record<number, string> = {
  1: "Dubai Based",
  2: "Abu Dhabi Based",
  3: "Others",
};

export const ROLE = {
  ADMIN: 1,
  SUB_ADMIN: 2,
  AGENT: 3,
  INDIVIDUAL_USER: 4,
  AGENCY: 5,
  ALL: 6,
  AFFILIATE_MEMBER: 7,
  SUB_ADMIN_FOR_COMPANY: 8,
};

export const SUBSCRIPTION_TYPE = {
  MONTHLY: "1",
  QUARTERLY: "3",
  YEARLY: "12",
};

export const SUBSCRIPTION_NAME: Record<number, string> = {
  1: "Monthly",
  3: "Quarterly",
  12: "Yearly",
};

export const BOOST_TYPE = {
  SPOTLIGHT: "1",
  ELEVATE: "2",
  APEX: "3",
};

export const OFFER_STATUS = {
  PUBLISHED: 1,
  CLAIMED: 2,
  UNDER_OFFER: 3,
  UNPUBLISHED: 4,
  TEMPORARY_UNPUBLISHED: 5,
};

export const LEAD_TYPE = {
  CALL: 1,
  IN_APP_CHAT: 2,
  EMAIL: 3,
  WHATSAPP: 4,
  MANUAL: 6,
};

export const CATEGORY_TYPE = {
  CATEGORY: "category",
  SUB_CATEGORY: "subcategory",
  BOTH: "both",
};

export const ALERT_TYPE: Record<number, string> = {
  1: "Hourly",
  2: "Daily",
  3: "Every 3 days",
  4: "Weekly",
  5: "Off",
};

export const XML_PROPERTY_TYPE = {
  PREVIOUSLY_PUBLISHED_PROPERTIES: 1,
  NEWLY_ADDED_PROPERTIES: 2,
  XML_DELETED_PROPERTIES: 3,
  ALL: 4,
  UNPUBLISHED_XML_PROPERTIES: 5,
};

export const LISTING_TYPE: Record<number, string> = {
  1: "STANDARD",
  2: "FEATURED",
  3: "PREMIUM",
};

export const PROPERTY_VERIFICATION_STATUS = {
  PENDING: 1,
  APPROVED: 2,
  REJECT: 3,
};

export const AUTO_XML_TYPE = {
  NEWLY_ADDED: 1,
  PREVIOUSLY_PUBLISHED: 2,
  XML_DELETED: 3,
  LISTING_ACTION_TRACKER: 4,
};

export const FURNISHED_TYPE = {
  FURNISHED: 1,
  UNFURNISHED: 2,
  PARTLY_FURNISHED: 3,
};

export const TOKEN_CREDIT_TYPE = {
  RENEWED_TOKEN_EVERY_MONTH: 1,
  RECEIVED_TOKENS_BY_ADMIN: 2,
};

export const NOTIFICATION_TYPE = {
  PUSH: 2,
  EMAIL: 4,
};

export const SUBSCRIPTION = {
  TRIAL: 1,
  NORMAL: 2,
};
